/**
 * Glifo do Instagram (câmera arredondada). O lucide-react 1.x tirou os ícones
 * de marca, então fica aqui — mesmo contrato do lucide: `size` vira os
 * atributos width/height do SVG (nunca className de tamanho), traço em
 * currentColor.
 */
export function InstagramIcon({
  size = 16,
  strokeWidth = 1.75,
  className,
}: {
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" stroke="none" />
    </svg>
  );
}
